import { type PropsWithChildren } from 'react';

import './kbd-shortcut.css';

type KbdProps = {
  letter?: string;
  meta?: boolean;
};

/**
 * Gets the modifer key for the users current platform
 *
 * Note: this is using a deprecated api but is still the suggested
 * way on mdn https://developer.mozilla.org/en-US/docs/Web/API/Navigator/platform#examples
 */
const getMetaKey = () => {
  let metaKey = '^';
  if (
    navigator.platform.indexOf('Mac') === 0 ||
    navigator.platform === 'iPhone'
  ) {
    metaKey = '⌘';
  }

  return metaKey;
};

/* -------------------------------------------------------------------------------------------------
 * Kbd
 * -----------------------------------------------------------------------------------------------*/
const Kbd = ({ letter, meta }: KbdProps) => {
  const key = meta ? getMetaKey() : letter;
  return <kbd className="kbd">{key}</kbd>;
};

/* -------------------------------------------------------------------------------------------------
 * KbdShortcut
 * -----------------------------------------------------------------------------------------------*/
type KbdShortcutProps = {
  title?: string;
};

const KbdShortcut = ({
  children,
  title,
}: PropsWithChildren<KbdShortcutProps>) => {
  return (
    <div className="kbd-shortcut">
      <span className="kbd-shortcut-title">{title}</span>
      {children}
    </div>
  );
};

export { KbdShortcut, Kbd };
export type { KbdShortcutProps, KbdProps };
